import { lockUnlockFiles, perminentDeleteFiles, renameFileInFiles, restoreFiles, starUnstarFiles, trashEmptyFiles, trashFiles, updateFilePermission, uploadFileInFiles } from "store/slices/files";
import { acceptAccessRequest, createAccessRequest, createFolder, createSharedDetailPermission, declineAccessRequest, lockUnlockFileAndFolder, moveFilesAndFolders, removeFileAndFolderPemission, removeSharedDetailPermission, renameFile, restoreFilesAndFolder, starUnstarItems, trashFilesAndFolders, updateFileFolderPermission, updateFolderItems, updateRecentFile, updateRecentFolder, updateSharedDetailPermission, updateUserProfile, uploadfiles, uploadFolder } from "store/slices/folders";
import { acceptShareRequest, createFileAndFolderPermission, emptyTrashOpenFile, lockUnlockItemsGeneral, moveFilesAndFoldersGeneral, permanentDeleteFilesOpenFile, recentFolder, recentItem, removeFileAndFolderPemissionGeneral, renameFileInHome, restoreFilesAndFoldersGeneral, restoreFilesOpenFile, starUnstarItemsGeneral, trashFilesAndFoldersGeneral, updateFileAndFolderGeneral, updateFolderItemsInHome, updateIsSharedGeneral, updateStorageUsed } from "store/slices/general";
import { updateDrivePrefrence, updateProfile } from "store/slices/profile";
import { addTrashItems, perminentDeleteFilesAndFolders, restoreItems, trashEmpty } from "store/slices/trash";


export const registerSocketEvents = ({
  socket,
  dispatch,
  user
}) => {
  if (!socket) return;

  const handleProfileUpdate = (data) => {
    if (data?.type === "profile_update") {
      dispatch(updateProfile(data?.data));
      dispatch(updateUserProfile(data?.data));
    }

  };
  const handleUpdateItems = (data) => {
    switch (data?.type) {
      case "folder_update":
        dispatch(updateFolderItems(data?.data));
        dispatch(updateFolderItemsInHome(data?.data));
        break;

      case "folder_create":
        dispatch(createFolder(data?.data));
        break;

      case "file_rename":
        dispatch(renameFileInHome(data?.data));
        dispatch(renameFile(data?.data));
        dispatch(renameFileInFiles(data?.data));
        break;

      case "file_upload":
        dispatch(uploadfiles(data?.data));
        dispatch(uploadFileInFiles(data?.data));
        // dispatch(uploadFileInGeneral(data?.data));
        break;

      case "item_trash":
        dispatch(trashFilesAndFolders(data?.data));
        dispatch(trashFiles(data?.data));
        dispatch(trashFilesAndFoldersGeneral(data?.data));
        dispatch(addTrashItems(data?.data))
        break;

      case "item_permanent_delete":
        dispatch(perminentDeleteFilesAndFolders(data?.data))
        dispatch(perminentDeleteFiles(data?.data))
        dispatch(permanentDeleteFilesOpenFile(data?.data));
        break;

      case "trash_empty":
        dispatch(trashEmpty())
        dispatch(trashEmptyFiles())
        dispatch(emptyTrashOpenFile());
        break;

      case "folder_upload":
        dispatch(uploadFolder(data?.data))
        break;

      case "item_moved":
        dispatch(moveFilesAndFolders(data?.data))
        dispatch(moveFilesAndFoldersGeneral(data?.data))
        break;

      case "item_restore":
        dispatch(restoreFilesAndFolder(data?.data));
        dispatch(restoreItems(data?.data));
        dispatch(restoreFiles(data?.data));
        dispatch(restoreFilesOpenFile(data?.data));
        dispatch(restoreFilesAndFoldersGeneral(data?.data));
        break;

      case "item_unstarred":
      case "item_starred":
        dispatch(starUnstarItems(data?.data));
        dispatch(starUnstarItemsGeneral(data?.data));
        dispatch(starUnstarFiles(data?.data));
        break;

      case "item_secure":
      case "item_unsecure":
        dispatch(lockUnlockFileAndFolder(data?.data));
        dispatch(lockUnlockItemsGeneral(data?.data));
        dispatch(lockUnlockFiles(data?.data));
        break;

      default:
        break;
    }
  };

  const handleSharingChange = (data) => {
    switch (data?.type) {

      case "file_permission_updated":
      case "folder_permission_updated":
        dispatch(updateFileFolderPermission({ ...data?.data, profileId: user?.id }))
        dispatch(updateFileAndFolderGeneral({ ...data?.data, profileId: user?.id }))
        dispatch(updateFilePermission({ ...data?.data, profileId: user?.id }))
        dispatch(updateSharedDetailPermission({ ...data?.data, profileId: user?.id }))
        break;
      case "file_permission_remove":
      case "folder_permission_remove":
        dispatch(removeFileAndFolderPemissionGeneral({ ...data?.data, profileId: user?.id }))
        dispatch(removeFileAndFolderPemission({ ...data?.data, profileId: user?.id }))
        dispatch(removeSharedDetailPermission({ ...data?.data, profileId: user?.id }))
        dispatch(updateIsSharedGeneral({ ...data?.data, profileId: user?.id }))
        break;

      case "file_permission_created":
      case "folder_permission_created":
        dispatch(
          createFileAndFolderPermission({ ...data?.data, profileId: user?.id })
        );
        dispatch(createSharedDetailPermission({ ...data?.data, profileId: user?.id }))
        break;

      default:
        break;
    }
  }

  const handleSettingsUpdate = (data) => {
    if (data?.type === "setting_updated") {
      dispatch(updateDrivePrefrence(data?.data))
      dispatch(updateStorageUsed(data?.data))
    }
  };

  const handleRecentItem = (data) => {
    if (data?.type === "file_open") {
      dispatch(recentItem(data?.data))
      dispatch(updateRecentFile(data?.data))
    }
    if (data?.type === "folder_open") {
      dispatch(recentFolder(data?.data))
      dispatch(updateRecentFolder(data?.data?.folder))
    }
  }

  const handleActionManagement = (data) => {
    if (data?.type === "access_request_accepted") {
      dispatch(acceptShareRequest({ ...data?.data, profileId: user?.id }))
      dispatch(acceptAccessRequest({ ...data?.data, profileId: user?.id }))
    }
    if (data?.type === "access_request_created") {
      dispatch(createAccessRequest({ ...data?.data, profileId: user?.id }))
    }
    if (data?.type === "access_request_declined") {
      dispatch(declineAccessRequest({ ...data?.data, profileId: user?.id }))
    }
  }


  socket.on("profile_updated", handleProfileUpdate);
  socket.on("item_changed", handleUpdateItems);
  socket.on("setting_updated", handleSettingsUpdate);
  socket.on("sharing_change", handleSharingChange);
  socket.on("item_recent", handleRecentItem)
  socket.on("access_request_action", handleActionManagement)

  return () => {
    socket.off("profile_updated", handleProfileUpdate);
    socket.off("item_changed", handleUpdateItems);
    socket.off("setting_updated", handleSettingsUpdate);
    socket.off("sharing_change", handleSharingChange);
    socket.off("item_recent", handleRecentItem)
    socket.off("access_request_action", handleActionManagement)

  };
};
